import { Avatar, Box, Typography, Stack } from '@mui/material';
import defaultUserThumbnail from '../../assets/default_user_thumbnail.svg';
import { Link, useLocation } from 'react-router-dom';
import theme from '../../theme';
import GradeIcon from './GradeIcon';
import { getPageTypeFromPath } from '../../lib/gaParams';
import { trackUserProfileClick } from '../../lib/gaEvents';
import { useUserStore } from '../../stores/userStore';

const UserWithProfile = ({
  username,
  profileImageUrl,
  userNickname,
  grade,
  onClick,
  variant = 'default', // 'small', 'default', 'large'
  spacing = 0.5,
  sx = {},
}) => {
  const userUrl = userNickname ? `/users/${encodeURIComponent(userNickname)}` : '#';
  const location = useLocation();
  const user = useUserStore((state) => state.user);

  // variant에 따른 크기 설정
  const sizes = {
    small: {
      avatar: { xs: 22, md: 24 },
      font: { xs: 13, md: 14 },
    },
    default: {
      avatar: 24,
      font: 14,
    },
    large: {
      avatar: 32,
      font: 14,
    },
  };

  const currentSizes = sizes[variant] || sizes.default;

  const handleClick = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      e.stopPropagation();
      if (userNickname) {
        trackUserProfileClick(
          {
            contentName: userNickname,
            pageType: getPageTypeFromPath(location.pathname),
          },
          user,
        );
      }
      if (onClick && userNickname) {
        onClick(userNickname);
      }
    }
  };

  return (
    <Link
      to={userUrl}
      style={{
        display: 'inline-flex',
        maxWidth: '100%',
        minWidth: 0,
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Stack
        direction="row"
        spacing={spacing}
        alignItems="center"
        sx={{ minWidth: 0, maxWidth: '100%', ...sx }}
      >
        <Avatar
          src={profileImageUrl || defaultUserThumbnail}
          sx={{
            width: currentSizes.avatar,
            height: currentSizes.avatar,
            cursor: onClick && userNickname ? 'pointer' : 'default',
            border: `1px solid ${theme.palette.grey.line}`,
          }}
          onClick={handleClick}
        />
        <Box
          sx={{
            flex: '0 1 auto',
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            minWidth: 0,
            maxWidth: '100%',
            width: 'fit-content',
          }}
        >
          <Typography
            onClick={handleClick}
            sx={{
              flex: '0 1 auto',
              minWidth: 0,
              maxWidth: '100%',
              fontSize: currentSizes.font,
              fontWeight: '700',
              color: theme.palette.black[6],
              cursor: onClick && userNickname ? 'pointer' : 'default',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5',
            }}
          >
            {username}
          </Typography>
          <GradeIcon grade={grade} />
        </Box>
      </Stack>
    </Link>
  );
};

export default UserWithProfile;
